import { Reducer } from "redux";

import { RefreshTokenResponse } from "../models/api/User";
import { Refresh_Token_SSO_ActionTypes } from "../models/dispatchTypes/User";
import { Refresh_Token_SSO_ActionDispatchTypes } from "../constants/User";

const initialState: RefreshTokenResponse = {
  loading: false,
  response: null,
  error: null,
};

const RefreshTokenReducer: Reducer<
  RefreshTokenResponse,
  Refresh_Token_SSO_ActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case Refresh_Token_SSO_ActionDispatchTypes.REFRESH_TOKEN_SSO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default RefreshTokenReducer;
